import React, { useEffect } from 'react'
import { useLog, useTbViewStore } from '@vt/hooks'
import { InlineRender } from '@ow/ditto'
import { get, pick } from 'lodash-es'
import { dayjsInit, getWaterMarkDefsItemInfo } from '@ow/utils'
import { Skeleton, Timeline, Button } from '@mantine/core'
import nulldata from './assets/nulldata.png'

const Log = function ({ data }) {
  const { loading, logsData, tbs, setLoading, setOrder, order } = useLog(data)
  const { tbId, fields, exporterConfig } = useTbViewStore((state) =>
    pick(state, ['tbId', 'fields', 'exporterConfig'])
  )

  const { waterMarkDefs } = exporterConfig || {}

  const transFormKey = (d) => {
    const result = tbs[d.tbId].fields.filter((field) => {
      return field.slug === d.key
    })
    return get(result[0], 'title', '')
  }

  useEffect(() => {
    setLoading(false)
  }, [data])

  const changeOrder = () => {
    if (order === 'desc') {
      setOrder('asc')
    } else {
      setOrder('desc')
    }
  }

  return (
    <div>
      <div
        style={{ position: 'absolute', top: '72px', right: '20px' }}
        onClick={changeOrder}
      >
        <Button
          size="xs"
          type="primary"
          variant="outline"
          disabled={!logsData || logsData.length === 0}
        >
          {order === 'desc' ? '正序' : '倒序'}
        </Button>
      </div>
      {loading && (
        <div className="mt-2">
          <Skeleton height={10} radius="xl" />
          <Skeleton height={10} mt={12} radius="xl" />
          <Skeleton height={10} mt={12} radius="xl" />
        </div>
      )}
      {!loading &&
        (logsData.length === 0 ? (
          <div className="flex flex-col gap-6 w-full text-center">
            <img
              src={nulldata}
              alt="nulldata"
              style={{ width: '200px', margin: 'auto' }}
            />
            <div className="text-sm">暂无记录</div>
          </div>
        ) : (
          <Timeline
            active={logsData.length}
            color="rgb(var(--ow-primary-color))"
            lineWidth={2}
            bulletSize={14}
          >
            {logsData.map((d, i) => {
              return (
                <Timeline.Item
                  title={d.actionDescribe}
                  key={`time-line-item-${i}`}
                >
                  <div className="flex items-center gap-1 text-sm mt-2.5">
                    {tbs && (
                      <>
                        <InlineRender
                          value={d.operateUsers}
                          defs={{
                            ...tbs[d.tbId].fields.find(
                              (v) => v.slug === 'operateUsers'
                            ),
                            renderTitleHidden: true,
                          }}
                          rowData={d}
                          fields={tbs[d.tbId].fields}
                        />
                        <div>/</div>
                        <InlineRender
                          value={d.operateOrganizations}
                          defs={{
                            ...tbs[d.tbId].fields.find(
                              (v) => v.slug === 'operateOrganizations'
                            ),
                            renderTitleHidden: true,
                          }}
                          rowData={d}
                          fields={tbs[d.tbId].fields}
                        />
                      </>
                    )}
                  </div>
                  <div
                    style={{ color: 'rgba(0,0,0,0.4)' }}
                    className="mt-2.5 text-sm"
                  >
                    {dayjsInit(d.operationAt).format('YYYY-MM-DD HH:mm:ss')}
                  </div>
                  {tbs &&
                    d.data &&
                    d.data.map((da) => {
                      if (
                        (da.slug.includes('_otherSelects') ||
                          da.slug.includes('_otherSelect')) &&
                        (!da.value || da.value.length === 0)
                      ) {
                        return null
                      }
                      const cfield = fields.find((f) => f.slug === da.slug)
                      let finaValue = da.value

                      if (
                        cfield &&
                        (cfield.hidden || cfield.type === 'product')
                      ) {
                        return null
                      }
                      if (
                        da.tbId === tbId &&
                        cfield &&
                        cfield.type === 'media'
                      ) {
                        finaValue = (da.value || []).map((m) => {
                          const { extInfo } = m
                          const waterMarkInfo = getWaterMarkDefsItemInfo(
                            waterMarkDefs,
                            { ...data, extInfo }
                          )
                          return { ...m, waterMarkInfo }
                        })
                      }

                      return (
                        <div
                          key={da.key}
                          className="text-primary gap-1 flex flex-col mt-2.5 text-sm"
                        >
                          <div>{transFormKey(da)}:</div>
                          <InlineRender
                            value={finaValue}
                            defs={{
                              ...tbs[da.tbId].fields.find(
                                (v) => v.slug === da.key
                              ),
                              renderTitleHidden: true,
                            }}
                            rowData={da}
                            fields={tbs[da.tbId].fields}
                          />
                        </div>
                      )
                    })}
                </Timeline.Item>
              )
            })}
          </Timeline>
        ))}
    </div>
  )
}

export default Log
